import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";

import { signUp } from "../../services/auth";
import { Mixpanel } from "../../mixpanel";

import * as actionCreators from "../../actions/user";

import acHealthLogo from "../../resources/images/logo.png";

import "../../resources/styles/SignUpProvider.css";

class SignUpProvider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      role: "Provider",
      error: "",
      isTermAgreed: false,
    };
  }

  createAccount() {
    if (_.isEmpty(this.state.email) || _.isEmpty(this.state.password)) {
      this.setState({ error: "Please fill out all required fields" });
    } else if (this.checkPassword()) {
      signUp(
        this.state.email,
        this.state.password,
        this.state.firstName,
        this.state.lastName,
        (ret) => {
          if (_.isEmpty(ret.email)) {
            let msg = ret.description != null ? ret.description : ret.error;
            msg = msg.includes("email format validation")
              ? "You must enter a valid email address"
              : msg;
            this.setState({ error: msg });
          } else {
            // successfully signed up, login automatically
            let defaultProfilePicture =
              "https://s3-us-west-2.amazonaws.com/system-data/web-app/images/avatar_default_user_profile.png";
            let profile = {
              email: ret.email,
              nickname: ret.user_metadata.given_name,
              picture: defaultProfilePicture,
            };
            let user = {
              email: ret.email,
              loginType: "auth0",
              firstName: ret.user_metadata.given_name,
              lastName: ret.user_metadata.family_name,
              isProvider: this.state.role === "Patient" ? false : true,
              profilePhotoUrl: defaultProfilePicture,
            };

            Mixpanel.track("Sign up", {
              Email: ret.email,
              isProvider: this.state.role === "Patient" ? false : true,
              Platform: "Web",
            });
            // call server to login and get user ID
            this.props.userLogin(user, profile);
            // go to the next page
            if (this.state.role === "Provider") {
              this.props.history.push("/home");
            } else {
              this.props.history.push("/view-channels");
            }
          }
        },
        (ret) => {
          this.setState({ error: ret.error });
        }
      );
    }
  }

  checkHasNumbers() {
    let password = this.state.password;
    if (password.match(/[0-9]+/)) {
      return true;
    } else {
      return false;
    }
  }

  checkHasCharacterSmall() {
    let password = this.state.password;
    if (password.match(/[a-z]+/)) {
      return true;
    } else {
      return false;
    }
  }

  checkHasCharacterCapital() {
    let password = this.state.password;
    if (password.match(/[A-Z]+/)) {
      return true;
    } else {
      return false;
    }
  }

  checkHasCharacter() {
    let password = this.state.password;
    if (password.match(/[$@#&!]+/)) {
      return true;
    } else {
      return false;
    }
  }

  checkPassword() {
    if (this.state.password.length < 8) {
      this.setState({
        error: "Your password must have at least 9 characters!",
      });
      return false;
    } else {
      if (this.checkHasNumbers()) {
        if (this.checkHasCharacterSmall()) {
          if (this.checkHasCharacterCapital()) {
            if (this.checkHasCharacter()) {
              return true;
            } else {
              this.setState({
                error: "Your password must have at least one character($@#&!)!",
              });
              return false;
            }
          } else {
            this.setState({
              error: "Your password must have at least one capital letter!",
            });
            return false;
          }
        } else {
          this.setState({
            error: "Your password must have at least one small letter!",
          });
          return false;
        }
      } else {
        this.setState({
          error: "Your password must have at least one number!",
        });
        return false;
      }
    }
  }

  render() {
    return (
      <div className="sign-up-provider">
        <div className="sign-up-provider__box">
          <div className="sign-up-provider__header">
            <img src={acHealthLogo} width="40%" />
            <h3>Create Account</h3>
          </div>
          <di className="sign-up-provider__inputs">
            <input
              className="sign-up-provider__input"
              placeholder="Email *"
              value={this.state.email}
              onChange={(event) =>
                this.setState({
                  error: "",
                  email: event.target.value,
                })
              }
            />
            <input
              className="sign-up-provider__input"
              placeholder="Password *"
              type="password"
              value={this.state.password}
              onChange={(event) =>
                this.setState({
                  error: "",
                  password: event.target.value,
                })
              }
            />
            <input
              className="sign-up-provider__input"
              placeholder="First name"
              value={this.state.firstName}
              onChange={(event) =>
                this.setState({
                  firstName: event.target.value,
                })
              }
            />
            <input
              className="sign-up-provider__input"
              placeholder="Last name"
              value={this.state.lastName}
              onChange={(event) =>
                this.setState({
                  lastName: event.target.value,
                })
              }
            />
          </di>
          <div className="sign-up-provider__actions">
            <p>{this.state.error}</p>
            <button
              onClick={() => this.createAccount()}
              disabled={
                _.isEmpty(this.state.email) || _.isEmpty(this.state.password)
              }
            >
              SIGN UP
            </button>
            <label>
              Have an account ?
              <a
                onClick={() => {
                  this.props.history.push("/");
                }}
              >
                {" "}
                Login{" "}
              </a>
            </label>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ user }) {
  return {
    userId: user.userId,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpProvider);



// WEBPACK FOOTER //
// ./src/layout/Signup/SignUpProvider.js